<template>
  <el-card class="h-full inset-0 z-10">
    <div class="h-full flex flex-col">
      <div class="flex justify-between items-center">
        <span
          v-if="['update', 'create'].includes(operateApiProps.editType)"
          class="border-l-3 border-color-primary pl-10px text-18px"
          >{{ operateApiProps.title }}</span
        >
        <div v-else>
          <el-page-header @back="goBack" :content="operateApiProps.title"> </el-page-header>
        </div>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-form
          class="clear-placeholer"
          size="mini"
          label-width="150px"
          v-loading="evaluationLoading"
          :rules="evaluationRules"
          ref="evaluationRef"
          :model="evaluationForm"
        >
          <el-row class="px-20px">
            <el-col :span="8">
              <el-form-item label="评价项目" prop="project">
                <el-input
                  size="small"
                  v-model="evaluationForm.project"
                  maxlength="100"
                  placeholder="请输入评价项目"
                  :disabled="!['update', 'create'].includes(operateApiProps.editType)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="标准分" prop="standardScore">
                <el-input-number
                  size="small"
                  v-model="evaluationForm.standardScore"
                  :controls="false"
                  class="w-full"
                  :precision="2"
                  placeholder="请输入标准分"
                  :disabled="!['update', 'create'].includes(operateApiProps.editType)"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="评价内容" prop="content">
                <el-input
                  :disabled="!['update', 'create', 'upload'].includes(operateApiProps.editType)"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 12 }"
                  class="!w-full"
                  :rows="3"
                  maxlength="10000"
                  show-word-limit
                  v-model="evaluationForm.content"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="评价标准" prop="scoringStandar">
                <el-input
                  :disabled="!['update', 'create', 'upload'].includes(operateApiProps.editType)"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 12 }"
                  class="!w-full"
                  :rows="scoringStandarRows"
                  maxlength="10000"
                  show-word-limit
                  v-model="evaluationForm.scoringStandar"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input
                  :disabled="!['update', 'create', 'upload'].includes(operateApiProps.editType)"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 12 }"
                  class="!w-full"
                  :rows="3"
                  maxlength="10000"
                  show-word-limit
                  v-model="evaluationForm.remark"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="flex justify-center mt-20px" v-if="operateApiProps.editType !== 'read'">
        <el-button
          size="small"
          type="primary"
          @click="save()"
          :loading="saveLoading"
          v-if="operateApiProps.editType !== 'read'"
          >保存</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="goBack">取消</el-button>
      </div>
      <div
        slot="footer"
        class="dialog-footer flex justify-center items-center"
        v-if="!(operateApiProps.editType === 'read')"
      ></div>
    </div>
  </el-card>
</template>
<script>
import { SafetyEvaluationApi } from '@wiz-api/safety-evaluation-management'
import clearPlaceholder from '@/assets/js/safety/ClearPlaceholder'

const safetyEvaluationApi = new SafetyEvaluationApi()
export default {
  components: {},
  data() {
    return {
      scoringStandarRows: 3,
      evaluationDangerFactorList: [],
      evaluationDangerTypeList: [],
      saveLoading: false,
      evaluationData: [],
      operateApiProps: {
        title: '新增评价智库',
        editType: 'create',
        visible: false,
      },
      evaluationLoading: false,
      evaluationForm: {
        uploadFileId: '',
      },
      evaluationRules: {
        project: [{ required: true, message: '请输入评价项目', trigger: ['blur'] }],
        standardScore: [{ required: true, message: '请输入标准分', trigger: ['blur'] }],
        content: [{ required: true, message: '请输入评价内容', trigger: ['blur'] }],
        scoringStandar: [{ required: true, message: '请输入评分标准', trigger: ['blur'] }],
      },
    }
  },
  async created() {
    if (this.$route.query.id) {
      this.getDetail()
      if (this.$route.query.type === 'update') {
        this.operateApiProps.title = '修改'
        this.operateApiProps.editType = 'update'
      } else {
        this.operateApiProps.editType = 'read'
        this.operateApiProps.title = '详情'
        clearPlaceholder('.clear-placeholer')
      }
    }
  },
  methods: {
    async getDetail() {
      const [err, res] = await safetyEvaluationApi.get(this.$route.query.id)
      if (!err) {
        this.evaluationForm = res
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    save() {
      this.$refs.evaluationRef.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          if (this.operateApiProps.editType === 'update') {
            const [err, res] = await safetyEvaluationApi.update(this.$route.query.id, {
              body: this.evaluationForm,
            })
            if (!err) {
              this.$message.success('编辑成功')
              this.goBack()
            }
          } else {
            const [err, res] = await safetyEvaluationApi.insert({
              body: this.evaluationForm,
            })
            if (!err) {
              this.$message.success('保存成功')
              this.goBack()
            }
          }
          this.saveLoading = false
        }
      })
    },
    fileIdChange(key) {
      this.$refs[key].$emit('el.form.change')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
.evaluation-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
<style lang="scss">
.evaluation-select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
